// src/components/Skills.js
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './Skills.css';
import Pytorch from '../../assets/pytorch.png';
import ReactJs from "../../assets/React.png"
import Flask from "../../assets/flask.png"
import Javascript from "../../assets/javascript.png"
import Mongo from "../../assets/mongoDB.png"
import Mysql from "../../assets/mysql.png"
import Node from "../../assets/node.png"
import Python from "../../assets/python.png"
import Tensorflow from "../../assets/tensorflow.png"
import Wordpress from "../../assets/wordpress.png"

const Skills = () => {
  return (
    <Container fluid="md" className="skill-section" id='skills'>
      <h2><span>My </span> Skills</h2>
      <Row className="tech-stack-row">
        <Col className="tech-stack-white">
          <img src={ReactJs} height={"50px"} alt="react" />
          <h4>React</h4>
        </Col>
        <Col className="tech-stack-black">
          <img src={Javascript} height={"50px"} alt="javascript" />
          <h4>JavaScript</h4>
        </Col>
        <Col className="tech-stack-white">
          <img src={Flask} height={"50px"} alt="flask" />
          <h4>Flask</h4>
        </Col>
        <Col className="tech-stack-white">
          <img src={Node} height={"50px"} alt="node" />
          <h4>Node</h4>
        </Col>
        <Col className="tech-stack-white">
          <img src={Wordpress} height={"50px"} alt="wordpress" />
          <h4>Wordpress</h4>
          </Col>
      </Row>
      <Row className="tech-stack-row">
        <Col className="tech-stack-white">
          <img src={Pytorch} height={"50px"} alt="Pytorch" />
          <h4>PyTorch</h4>
        </Col>
        <Col className="tech-stack-white">
        <img src={Tensorflow} height={"50px"} alt="tensorflow" />
        <h4>TensorFlow</h4>
        </Col>
        <Col className="tech-stack-white">
        <img src={Python} height={"50px"} alt="python" />
        <h4>Python</h4>
        </Col>
        <Col className="tech-stack-white">
        <img src={Mongo} height={"50px"} alt="mongodb" />
        <h4>MongoDB</h4>
        </Col>
        <Col className="tech-stack-white">
        <img src={Mysql} height={"50px"} alt="mysql" />
        <h4>MySQL</h4>
        </Col>
      </Row>
    </Container>
  );
};

export default Skills;
